module.exports = __webpack_public_path__ + "img/38_34.52f54cae.png";